import { Link, RouteWrapper, Subtitle } from '@/views/CrehanaLegal/components';

const TermsAndConditions = () => (
  <RouteWrapper>
    <section>
      <p>
        POR FAVOR LEA CUIDADOSAMENTE LOS PRESENTES TÉRMINOS Y CONDICIONES ANTES
        DE APROVECHAR, VISITAR O UTILIZAR CUALQUIER COMPONENTE DE LA PLATAFORMA
        DE CREHANA. ES NECESARIO TAMBIÉN LEER LAS POLÍTICAS DE PRIVACIDAD, EN
        DONDE DETALLAMOS NUESTRAS PRÁCTICAS DE MANEJO DE INFORMACIÓN{` `}
        <Link href="https://www.crehana.com/legal/politicas-de-privacidad/" />.
      </p>
      <p>
        NOS PREOCUPAMOS POR MANTENER SEGUROS A NUESTROS USUARIOS Y ESTAMOS EN
        CONSTANTE TRABAJO PARA RECOPILAR LA INFORMACIÓN DE MANERA CONFIDENCIAL.
        EL ACCESO Y/O UTILIZACIÓN DEL SITIO WEB POR CUALQUIER USUARIO (SEGÚN
        DICHO TÉRMINO SE DEFINE MÁS ADELANTE) IMPLICA LA PLENA ACEPTACIÓN DE
        TODAS LAS DISPOSICIONES INCLUIDAS EN EL PRESENTE DOCUMENTO Y EL ACUERDO
        DE SERVICIO RESPECTIVA FIRMADA POR EL CLIENTE.
      </p>
      <p>
        POR FAVOR LEA CUIDADOSAMENTE LOS PRESENTES TÉRMINOS Y CONDICIONES ANTES
        DE APROVECHAR, VISITAR O UTILIZAR CUALQUIER COMPONENTE DE LA PLATAFORMA
        DE CREHANA. ES NECESARIO TAMBIÉN LEER LAS POLÍTICAS DE PRIVACIDAD, EN
        DONDE DETALLAMOS NUESTRAS PRÁCTICAS DE MANEJO DE INFORMACIÓN{` `}
        <Link href="https://www.crehana.com/legal/politicas-de-privacidad/" />
        . NOS PREOCUPAMOS POR MANTENER SEGUROS A NUESTROS USUARIOS Y ESTAMOS EN
        CONSTANTE TRABAJO PARA RECOPILAR LA INFORMACIÓN DE MANERA CONFIDENCIAL.
        EL ACCESO Y/O UTILIZACIÓN DEL SITIO WEB POR CUALQUIER USUARIO (SEGÚN
        DICHO TÉRMINO SE DEFINE MÁS ADELANTE) IMPLICA LA PLENA ACEPTACIÓN DE
        TODAS LAS DISPOSICIONES INCLUIDAS EN EL PRESENTE DOCUMENTO Y EL ACUERDO
        DE SERVICIO RESPECTIVA FIRMADA POR EL CLIENTE. LOS PRESENTES TÉRMINOS Y
        CONDICIONES REGULAN LA RELACIÓN ENTRE CREHANA Y LOS CLIENTES EN RELACIÓN
        CON LA PRESTACIÓN DE LOS SERVICIOS Y LICENCIA PARA ACCESO DE CONTENIDO
        CONFORME AL ACUERDO DE SERVICIO FIRMADA ENTRE CADA CLIENTE Y CREHANA. EL
        CLIENTE DECLARA QUE ES UNA SOCIEDAD DEBIDAMENTE CONSTITUIDA Y QUE, EL
        CLIENTE Y SU REPRESENTANTE LEGAL, CUENTAN CON LA CAPACIDAD LEGAL
        NECESARIA PARA OBLIGARSE CONFORME A LOS PRESENTES TÉRMINOS Y
        CONDICIONES, ASÍ COMO CONFORME AL ACUERDO DE SERVICIO. DE IGUAL MANERA,
        INCLUYEN UNA ELECCIÓN DE DERECHO APLICABLE Y JURISDICCIÓN QUE APLICA A
        CUALQUIER RECLAMACIÓN QUE SE PRESENTE ANTE CREHANA. EL CLIENTE SE
        COMPROMETE A CUMPLIR Y HACER QUE LOS USUARIOS CUMPLAN CON ESTOS TÉRMINOS
        Y CONDICIONES, ASÍ COMO CON AQUELLOS TÉRMINOS Y CONDICIONES GENERALES
        DEL USO DE LA PLATAFORMA DE CREHANA QUE SE ENCUENTRAN PUBLICADOS EN LA
        SIGUIENTE DIRECCIÓN:
        <Link href="https://www.crehana.com/legal/terminos-y-condiciones/" />.
      </p>
      <p>
        DE IGUAL MANERA, INCLUYEN UNA ELECCIÓN DE DERECHO APLICABLE Y
        JURISDICCIÓN QUE APLICA A CUALQUIER RECLAMACIÓN QUE SE PRESENTE ANTE
        CREHANA. EL CLIENTE SE COMPROMETE A CUMPLIR Y HACER QUE LOS USUARIOS
        CUMPLAN CON ESTOS TÉRMINOS Y CONDICIONES, ASÍ COMO CON AQUELLOS TÉRMINOS
        Y CONDICIONES GENERALES DEL USO DE LA PLATAFORMA DE CREHANA QUE SE
        ENCUENTRAN PUBLICADOS EN LA SIGUIENTE DIRECCIÓN:
        <Link href="https://www.crehana.com/legal/terminos-y-condiciones/" />.
      </p>
    </section>
    <section>
      <Subtitle>1. Definiciones</Subtitle>
      <p>
        Los siguientes términos tendrán el significado que se señala a
        continuación cuando sean utilizados con mayúsculas, ya sea en singular o
        plural:
      </p>
      <p>
        <strong>Activación</strong>, significa la puesta en funcionamiento y la
        validación de todo aquello necesario para llevar a cabo la debida
        prestación de los Servicios, lo cual incluye de manera enunciativa, más
        no limitativa, las implementaciones, integraciones, revisión de
        documentación y demás acciones a realizar por parte de Crehana. Cabe
        precisar que la fecha de activación de las licencias inicia con el
        cargue del archivo HIRS, y no siempre coincide con la fecha de inicio
        del acuerdo de servicio.
      </p>
      <p>
        <strong>Acuerdo de Servicio</strong>, significa el documento celebrado
        mutuamente por Crehana y el Cliente, incluyendo todas aquellas órdenes
        que sean procesadas por medios electrónicos, mismo que prevé, al menos,
        los siguientes rubros: (i) la Contraprestación a ser cubierta por el
        Cliente por la prestación de los Servicios; (ii) el Plazo de los
        Servicios; (iii) el número de Usuarios autorizados para acceder a la
        Plataforma y sus Contenidos; (iv) información de facturación y pago; y
        (v) cualquier otra particularidad aplicable a la prestación de los
        Servicios al Cliente.
      </p>
      <p>
        <strong>Afiliada</strong>, significa cualquier entidad que directamente
        controla, es controlada o se encuentra bajo el control común de otra
        entidad.
      </p>
      <p>
        <strong>Cliente</strong>, significa la parte que ha ejecutado Acuerdo de
        Servicio con Crehana o que ha accedido a los Servicios de cualquier otra
        forma.
      </p>
      <p>
        <strong>Consultoría de activación y onboarding</strong>, significa el
        valor que pagará el Cliente de forma anual a Crehana, al inicio de los
        Servicios y posteriormente en cada aniversario, para que Crehana lleve a
        cabo la activación, adecuaciones, implementaciones, y mejoras en el
        acompañamiento y líneas de carrera del Cliente. El pago de este servicio
        se sumará al costo de la emisión de la primera factura y posteriormente
        se sumará a la factura de cada aniversario.
      </p>
      <p>
        <strong>Contenido</strong>, significa los productos de educación en
        línea ofrecidos a través de la Plataforma de Crehana.
      </p>
      <p>
        <strong>Contraprestación</strong>, significa el monto a pagar por parte
        del Cliente a Crehana por el (los) acceso(s) y/o Licencia(s) activad@(s)
        para liberar el ingreso a la Plataforma de Contenido durante el tiempo
        establecido en el Acuerdo de Servicio.
      </p>
      <p>
        <strong>Crehana</strong>, significa marca comercial del grupo de
        empresas ubicadas en:
      </p>
      <ul>
        <li>
          Crehana Education México, S. de R.L. de C.V. con dirección en Av.
          Paseo de la Reforma 296, piso 25, oficina 118, colonia Benito Juárez,
          Delegación Cuauhtémoc, Ciudad de México, México, C.P. 06600.
        </li>
        <li>
          Crehana Education Perú S.A.C. con dirección en Calle German Schreiber
          Gulsmanco 276, , distrito de San Isidro, Lima, Perú.
        </li>
        <li>
          Crehana Education Colombia S.A.S. con dirección en Calle 96 # 12 - 31
          Piso 4, en Bogotá D.C.
        </li>
        <li>
          Crehana Education Chile Capacitaciones SpA, con dirección en Avenida
          Providencia N° 1650, Oficina 611, comuna de Providencia, Ciudad de
          Santiago, Región Metropolitana.
        </li>
        <li>
          Crehana Chile SpA, con dirección en Avenida Providencia N° 1650,
          Oficina 611, comuna de Providencia, Ciudad de Santiago, Región
          Metropolitana.
        </li>
        <li>
          Crehana Education Inc., con domicilio en 2035 Sunset Lake Road, Suite
          B-2, city of Newark, county of New Castle, 19702, Delaware, USA.
        </li>
      </ul>
      <p>
        <strong>Datos personales</strong>, significan los datos personales de
        personas físicas o morales, identificadas o identificables, que estén en
        posesión de Crehana de los cuales el Cliente, en calidad de titular de
        la información, ha consentido para su tratamiento de conformidad con el
        aviso de privacidad
        (https://www.crehana.com/legal/politicas-de-privacidad/) o mediante la
        firma del Acuerdo de Servicio.
      </p>
      <p>
        <strong>Licencia o acceso</strong>, significa el derecho no exclusivo
        para acceder a los contenidos de titularidad de Crehana que se otorga a
        los Clientes por un periodo determinado de acuerdo con los términos
        seleccionados en el Acuerdo de Servicio y cualquier modificación o
        actualización que se vaya realizando.
      </p>
      <p>
        <strong>Partes</strong>, significa el Cliente y Crehana.
      </p>
      <p>
        <strong>Plataforma</strong>, significa el sitio web
        https://www.crehana.com/ , la plataforma virtual y/o otros medios
        digitales como aplicaciones para dispositivos smartphones con tecnología
        IOS o Android, tablets, SmartTv, entre otros, cuya titularidad
        corresponde a Crehana, dentro de la cual los Usuarios se registran para
        obtener el Servicio.
      </p>
      <p>
        <strong>Servicios</strong>, significa cualquiera de los Servicios que
        sean comprados por el Cliente conforme al Acuerdo de Servicio, y que
        están descritos en la Sección 2 de estos Términos y Condiciones.
      </p>
      <p>
        <strong>Términos y Condiciones</strong>, significa los presentes
        términos y condiciones generales de contratación de servicios de
        Crehana, según sean modificados de tiempo en tiempo así como aquellos a
        los que se hace referencia en la Sección 4., siguiente.
      </p>
      <p>
        <strong>Usuarios</strong>, significa aquellas personas internautas
        identificadas por el Cliente para tener acceso y derecho de uso de la
        Plataforma y acceso a los Servicios que correspondan conforme al
        presente Acuerdo de Servicio.
      </p>
    </section>

    <section>
      <Subtitle>2. Alcance de los Servicios</Subtitle>
      <p>
        Crehana se obliga a prestar al Cliente servicios de cloud computing bajo
        la modalidad de SaaS a través de su Plataforma mediante el otorgamiento
        de un acceso por tiempo limitado, o el desarrollo de cursos o programas
        a la medida según se haya acordado por Crehana y el Cliente en el
        Acuerdo de Servicio; el cual podrá ser modificado o actualizado conforme
        a las necesidades del Cliente durante su vigencia inicial o prórrogas.
      </p>
    </section>
    <section>
      <Subtitle>3. Otorgamiento de Licencia</Subtitle>
      <p>
        Sujeto al cumplimiento de los Términos y Condiciones, Crehana otorga a
        favor del Cliente una Licencia temporal, revocable, no exclusiva, no
        transferible, no sujeta a sublicencias, con obligación de pago de la
        Contraprestación, para acceder a los Contenidos de Crehana, así como el
        funcionamiento de dicha aplicación incluyendo las actualizaciones y
        soporte respecto de la plataforma de Crehana.
      </p>
    </section>
    <section>
      <Subtitle>4. Contraprestación</Subtitle>
      <p>
        A cambio del otorgamiento de los accesos según corresponda de
        conformidad con el Acuerdo de Servicio, el Cliente deberá pagar el valor
        total establecido en el mencionado acuerdo.
      </p>
      <p>
        Si entre las partes se acuerda una forma de pago diferente al 100%
        anticipado, este plazo se entenderá únicamente como una facilidad que
        Crehana ha considerado otorgar al Cliente para que no se vea afectado su
        flujo de caja a la fecha de suscripción del Acuerdo de Servicio, sin
        embargo, si el Cliente puede efectuar pagos de forma anticipada a las
        fechas establecidas en la factura, en el presente Acuerdo o en sus
        anexos, CREHANA no se opondrá y generará las facturas a que haya lugar
        para su legalización.
      </p>
      <p>
        De igual forma, si el Cliente decide terminar el Acuerdo de Servicio de
        forma anticipada sin una causa que dé lugar a imputar un incumplimiento
        a Crehana, el Cliente estará obligado a pagar dentro de los cinco (5)
        días hábiles previos a la fecha de terminación, de forma acelerada el
        monto que faltare para completar el valor del Acuerdo de Servicio, toda
        vez que con la suscripción del mismo, el Cliente comprende y acepta que
        el valor total del acuerdo se causa y se obliga a pagar en su totalidad
        desde la fecha de activación de los accesos, y cualquier plazo o
        modalidad de pago solo hace parte de una facilidad otorgada por Crehana
        para comodidad financiera del Cliente; en consecuencia, si el valor
        total señalado en el Acuerdo de Servicio ya fue pagado, el Cliente desde
        ahora conoce y acepta que Crehana no efectúa devoluciones o reembolsos
        si la terminación se da por parte unilateral de forma anticipada sin una
        causa que dé lugar a imputarle un incumplimiento a Crehana.
      </p>

      <p>
        Crehana podrá suspender los servicios al Cliente en caso de que el mismo
        no cumpla con los pagos en las fechas establecidas en el Acuerdo de
        Servicios, y hayan transcurrido 45 días en su retardo, esta suspensión
        en el servicio se realizará sin necesidad de notificación previa, ni
        responsabilidad alguna frente a el Cliente y/o los usuarios.
      </p>

      <p>
        En caso de prórroga bajo las mismas condiciones (igual alcance), el
        valor indicado en el Acuerdo de Servicios se ajustará de acuerdo con el
        incremento del Índice de Precios al Consumidor - IPC vigente en el año
        de la renovación o de conformidad con los precios de lista vigente en
        cada país.
      </p>
    </section>
    <section>
      <Subtitle>5. Propiedad Industrial y Derechos de autor</Subtitle>
      <p>
        El contenido de nuestra plataforma está protegido por la normativa de
        copyright vigente en los Estados Unidos de América, así como por las
        legislaciones locales de cada una de nuestras subsidiarias:
        <ul>
          <li>Chile: Ley 17336, Ley de Propiedad Intelectual.</li>
          <li>
            Colombia: Ley de Propiedad Intelectual: Ley 23 de 1982, Decisión 351
            de 1993, Ley 1801 de 2026, la Ley 1915 del 2018, los tratados
            internacionales en los cuales Colombia participa, y demás
            disposiciones del ordenamiento jurídico colombiano.
          </li>
          <li>
            México: la Ley Federal de Protección a la Propiedad Industrial y la
            Ley Federal del Derecho de Autor y los tratados internacionales
            correspondientes.
          </li>
          <li>
            Perú: la Ley sobre el Derecho de Autor (Decreto Legislativo 822),
            sus modificatorias y los tratados internacionales correspondientes.
          </li>
          <li>Argentina: La Ley de Propiedad Intelectual (Ley N° 11723).</li>
        </ul>
      </p>
      <p>
        Crehana, sus subsidiarias, afiliadas y/o licenciantes son los titulares
        de los derechos industriales e intelectuales relacionados y/o derivados
        de la Plataforma.
      </p>
      <p>
        Crehana, sus logotipos y todo el material que aparece en dicha
        plataforma, programas, documentos u otros, son marcas, nombres de
        dominio, nombres comerciales y obras artísticas, propiedad de Crehana,
        sus subsidiarias, afiliadas y/o licenciantes y están protegidos por los
        tratados internacionales y las leyes aplicables en materia de propiedad
        industrial e intelectual.
      </p>
      <p>
        Los derechos de autor sobre el contenido, organización, recopilación,
        compilación, información, logotipos, fotografías, imágenes, programas,
        aplicaciones, y en general cualquier información contenida o publicada
        en la plataforma, programas u otros, se encuentran debidamente
        protegidos a favor de Crehana, sus subsidiarias, afiliadas y/o
        licenciantes de conformidad con la legislación aplicable en materia de
        propiedad intelectual e industrial.
      </p>
      <p>
        Se prohíbe expresamente al Cliente y los Usuarios modificar, alterar o
        suprimir, ya sea en forma total o parcial, los avisos, marcas, nombres
        comerciales, señas, anuncios, logotipos o en general cualquier
        indicación que se refiera a la propiedad de la información contenida en
        la plataforma señalada. Así mismo, el Cliente y los Usuarios se
        comprometen a no mostrar, distribuir, conceder licencias, ejecutar,
        publicar, reproducir, duplicar, copiar, crear obras derivadas,
        modificar, vender, revender, explotar, transferir o cargar con fines
        comerciales, cualquier parte del Servicio, el uso del Servicio o el
        acceso al Contenido.
      </p>
      <p>
        Cualquier explotación total o parcial de los derechos de propiedad
        industrial e intelectual relacionados y/o derivados del Servicio
        requerirá del consentimiento previo por escrito de Crehana.
      </p>
      <p>
        Cualquier derecho de propiedad intelectual que hayan sido autorizados
        por Crehana para fines editoriales deberán contener la siguiente
        leyenda:
      </p>
      <p>
        “Derechos Reservados, © Crehana Education Colombia S.A.S., con domicilio
        en Calle 96 # 12 - 31 Piso 3, en Bogotá D.C.
      </p>
      <p>
        Derechos Reservados, © Crehana Education Chile Capacitaciones S.P.A.,
        con domicilio en Av. Providencia 1650, oficina 611, Santiago de Chile,
        Chile.
      </p>
      <p>
        Derechos Reservados, © Crehana Chile S.P.A., con domicilio en Av.
        Providencia 1650, oficina 611, Santiago de Chile, Chile.
      </p>
      <p>
        Derechos Reservados, © Crehana Education Inc., con domicilio en 2035
        Sunset Lake Road, Suite B-2, city of Newark, county of New Castle,
        19702, Delaware, USA.
      </p>
      <p>
        Derechos Reservados, © Crehana Education México, S. de R.L. de C.V., con
        domicilio en Av. Paseo de la Reforma 296, piso 25, oficina 118, colonia
        Benito Juárez, Delegación Cuauhtémoc, Ciudad de México, México, C.P.
        06600.
      </p>
      <p>
        Derechos Reservados, © Crehana Education Perú S.A.C., con domicilio
        Calle German Schreiber Gulsmanco 276, distrito de San Isidro, Lima,
        Perú.
      </p>
      <p>
        El Cliente y los Usuarios se obligan de forma irrevocable a no mostrar,
        distribuir, conceder licencias, ejecutar, publicar, reproducir,
        duplicar, copiar, crear obras derivadas, modificar, vender, revender,
        explotar, compartir su uso para diferentes usuarios, transferir o cargar
        con fines comerciales, cualquier parte del Servicio, el uso del Servicio
        y la Plataforma o el acceso a ésta y al Contenido.
      </p>
    </section>
    <section>
      <Subtitle>6.Responsabilidad</Subtitle>
      <p>
        Toda vez que el Software, los mecanismos, programas, procedimientos,
        signos distintivos, equipos, sistemas, técnicas y/o demás derechos de
        autor propiedad, de Crehana, no infringen de manera alguna ninguna clase
        de derecho de autor o de propiedad industrial, Crehana se deslinda de
        cualquier responsabilidad frente al Cliente, por lo cual no asume
        responsabilidad alguna de indemnizar o defender y sacar en paz y a salvo
        al Cliente de cualquier demanda, litigio, queja, acción, denuncia o
        reclamación, cualquiera que sea su naturaleza, que sea interpuesta en su
        contra, en la que se invoque tener un mejor derecho sobre cualquier
        derecho relacionado con la Licencia o los Servicios.
      </p>
      <p>
        Por su parte, el Cliente se obliga a indemnizar y mantener indemne y
        sacar en paz y a salvo a Crehana, sus Afiliadas, sus respectivos
        accionistas, consejeros, directivos, funcionarios, empleados,
        representantes, factores, asesores, subcontratistas, y agentes, en su
        persona y propiedades, de y contra reclamos de terceros, daños,
        responsabilidades y gastos, directamente relacionados o que surjan de un
        reclamo de terceros en relación a la Licencia y el uso de la misma, en
        el cual se alegue la violación de patentes, derechos de autor, marcas o
        secretos industriales y/o comerciales, y por conductas de negligencia
        grave, fraude o conducta dolosa del Cliente.
      </p>
      <p>
        El Cliente se obliga a notificar por escrito a Crehana, dentro de los [5
        (cinco)] días hábiles posteriores a que haya recibido un reclamo, y
        Crehana se reserva el derecho exclusivo de controlar y dirigir la
        investigación, defensa o arreglo de dicha reclamación, a expensas del
        Cliente.
      </p>
    </section>
    <section>
      <Subtitle>7. Publicidad y uso de marca</Subtitle>
      <p>
        Crehana o cualquiera de sus Afiliadas puede utilizar el nombre comercial
        y/o logotipo oficial del Cliente, de conformidad con con sus
        instructivos o manuales de marca, con el propósito de realizar
        comunicaciones en los canales de Crehana, salvo que se señale de otra
        forma en el Acuerdo de Servicio.
      </p>
      <p>
        Dichas comunicaciones estarán orientadas a resaltar el trabajo en
        conjunto de Crehana y el Cliente con el desarrollo de talento por medio
        de los canales de comunicación de Crehana, incluyendo sin limitar redes
        sociales, blog, página web.
      </p>
    </section>
    <section>
      <Subtitle>8. No exclusividad</Subtitle>
      <p>
        Los accesos a la Plataforma y la prestación propiamente dicha de los
        Servicios de Crehana al Cliente no otorga ningún derecho de exclusividad
        sobre el Contenido o los Servicios, de modo que Crehana podrá autorizar
        el uso del Contenido propio y prestar los Servicios a cualquier tercero,
        siempre que no represente un incumplimiento a sus obligaciones de
        Confidencialidad bajo estos Términos y Condiciones.
      </p>
    </section>
    <section>
      <Subtitle>9. Confidencialidad</Subtitle>
      <p>
        Toda información no pública, confidencial o propiedad de las Partes,
        incluyendo, pero no limitado a, especificaciones, muestras, patrones,
        diseños, planos, dibujos, documentos, datos, operaciones comerciales,
        listas de clientes, precios y descuentos, ya sea divulgados oralmente o
        divulgados en forma escrita, electrónica o por cualquier otro tipo o
        medios, en relación con la relación establecida por las partes (la
        <strong>&quot;Información Confidencial&quot;</strong>) es confidencial,
        y podrá ser utilizada únicamente para el uso de las Partes en la
        ejecución de los presentes Términos y Condiciones, y no podrá revelarse
        o copiarse a menos que sea autorizado previamente y por escrito por la
        otra Parte.
      </p>
      <p>
        A solicitud de una Parte, la otra deberá devolver inmediatamente todos
        los documentos y otros materiales o información recibidos La presente
        cláusula no será aplicable a la información que sea: (i) de dominio
        público; (ii) conocida antes de la divulgación; o (iii) obtenida
        legítimamente de manera no confidencial por parte de un tercero.
        Asimismo, las Partes reconocen que la información a que se refiere la
        presente cláusula constituye un activo trascendental para Crehana.
      </p>
      <p>
        En virtud de lo anterior, las Partes se comprometen y garantizan que
        toda la Información Confidencial que le sea proporcionada, será
        mantenida y tratada de modo confidencial y utilizada con el único fin de
        prestar los Servicios y cumplir con sus obligaciones bajo los Términos y
        Condiciones y el Acuerdo de Servicio y que la misma no será divulgada en
        modo alguno, en todo o en parte, durante el tiempo en las obligaciones
        permanezcan vigentes y después de su terminación, de no mediar
        consentimiento previo y por escrito de la otra Parte.
      </p>
      <p>
        Adicionalmente, Crehana se compromete a divulgar la Información
        Confidencial únicamente a las personas que precisen conocer la
        Información Confidencial a efecto de prestar los Servicios y que hayan
        sido informados previamente de los términos de la presente cláusula.
      </p>
      <p>
        Las obligaciones previstas en este documento continuarán plenamente
        vigentes y con la debida fuerza legal, sin perjuicio de la devolución o
        destrucción de la Información Confidencial después de la fecha de
        terminación de vigencia.
      </p>
    </section>
    <section>
      <Subtitle>10. No relación laboral</Subtitle>
      <p>
        La prestación de los Servicios de conformidad con los presentes Términos
        y Condiciones, así como el Acuerdo de Servicio y documentos relacionados
        con los mismos, regulan la prestación de servicios y no se podrá
        interpretar que el mismo crea una asociación, empresa, unidad económica
        o cualquier entidad similar entre las Partes, toda vez que consiste en
        una relación comercial autónoma. Derivado de lo anterior, cada una de
        las Partes es independiente y será responsable por sus propias
        obligaciones frente a terceros, así como ante sus obligaciones
        laborales, administrativas y fiscales, por lo tanto, las Partes acuerdan
        que sacarán en paz y a salvo a la otra Parte de cualquier reclamo o
        demanda interpuesta en contra de la otra parte como resultado de la
        violación de las obligaciones descritas en el presente, bajo su propio
        costo.
      </p>
      <p>
        Crehana reconoce expresamente que no existe ningún elemento de
        subordinación entre sus empleados y el Cliente. En términos de lo
        anterior, la responsabilidad derivada de las relaciones laborales entre
        Crehana y sus empleados, corresponde a ésta de manera única y exclusiva,
        por lo que Crehana será considerado como patrón de todos y cada uno de
        sus empleados al ser la única parte que se beneficia de los servicios
        prestados por dichos empleados.
      </p>
      <p>
        Con relación a lo anterior, Crehana se obliga de manera expresa a
        indemnizar y sacar en paz y a salvo al Cliente (incluyendo a su empresa
        matriz, subsidiarias, empresas relacionadas, sus clientes, sus
        accionistas, directores, empleados y/o consultores) de cualquier
        reclamo, demanda, riesgo, daño, pérdida, pérdida de utilidades, costos o
        gastos (incluyendo gastos legales) que se generen o que estén
        relacionados de cualquier manera con cualquier conflicto laboral, de
        seguridad social, comercial, civil o de cualquier naturaleza que se
        genere entre Crehana y cualquiera de sus empleados que argumente la
        existencia de una relación laboral entre dichos trabajadores y el
        Cliente y que reclamen de ésta el pago de cualquier prestación de
        carácter laboral, indemnización, salarios caídos, reinstalación, etc.,
        así como resultado de cualquier demanda, inspección y/o auditoría
        realizada por cualquier autoridad laboral con relación a los servicios
        desarrollados por los empleados de Crehana.
      </p>
      <p>
        Asimismo, Crehana será responsable del desempeño de su personal en la
        prestación de los Servicios, por lo que el Cliente no asume ninguna
        responsabilidad de carácter fiscal.
      </p>
    </section>
    <section>
      <Subtitle>11. Datos Personales</Subtitle>
      <p>
        Crehana se obliga a tratar los Datos Personales a los que tenga acceso
        por la relación con el Cliente como Información Confidencial, en
        términos de los presentes Términos y Condiciones, y a utilizar los
        mismos única y exclusivamente para los fines descritos en el aviso de
        privacidad de Crehana (
        <Link href="https://www.crehana.com/legal/avisos-de-privacidad/" />
        ), para brindar los Servicios al Cliente y los Usuarios.
      </p>
      <p>
        En caso de ser el Cliente quien recabe directamente datos personales
        sensibles y financieros de los Usuarios, se obliga a proporcionar a los
        Usuarios su aviso de privacidad que contenga los mismos fines que el
        aviso de privacidad de Crehana y manifiesta que conoce y comprende las
        obligaciones y responsabilidades de los Responsables y Encargados
        conforme a la Ley de Protección de Datos Personales aplicable en cada
        país así: México: Ley Federal de Protección de Datos Personales en
        Posesión de los Particulares, su Reglamento y demás relativos y
        aplicables; Colombia: Ley 1581 de 2012, Decreto Reglamentario 1377 de
        2013 y demás normas concordantes; Perú: Ley 29733 de 2011 y sus
        modificatorias; Chile Ley 19.628 sobre Protección de la Vida Privada y
        su normativa complementaria; obligaciones y responsabilidades que en
        este acto asume indefectiblemente.
      </p>
    </section>
    <section>
      <Subtitle>12. Modificaciones a los Términos y Condiciones</Subtitle>
      <p>
        Los presentes Términos y Condiciones pueden ser modificados por Crehana
        en cualquier momento, sin embargo, en todo caso siempre de forma previa
        se notificará de dichas modificaciones o actualizaciones a sus clientes
        y dentro de este aviso se enviará autorización para continuar con la
        relación contractual bajo estos nuevos términos y condiciones. Las
        modificaciones serán efectivas inmediatamente después de su publicación
        para los nuevos clientes y para aquellos antiguos luego de que sean
        aceptadas expresamente al acceder a la plataforma en la siguiente
        dirección: https://www.crehana.com/legal/terminos-y-condiciones-b2b/
      </p>
    </section>
    <section>
      <Subtitle>13. Cesión</Subtitle>
      <p>
        Crehana puede en todo momento ceder los derechos y las obligaciones bajo
        el Acuerdo de Servicio y los presentes Términos y Condiciones a: una
        Afiliada; (ii) el sucesor de Crehana en virtud de una fusión,
        reorganización corporativa, consolidación o venta; o (iii) a la entidad
        que adquiera la totalidad o una parte sustancial de los activos o
        negocios de Crehana para los cuales los bienes o servicios fueron
        adquiridos o están siendo utilizados.
      </p>
    </section>
    <section>
      <Subtitle>14. Derecho aplicable y elección de jurisdicción</Subtitle>
      <p>
        Las Partes acuerdan expresamente que los presentes Términos y
        Condiciones, así como el Acuerdo de Servicio y cualquier documento que
        derive de los mismos, serán regidos e interpretados de conformidad con
        las leyes de cada país donde tiene presencia legal Crehana y de acuerdo
        al domicilio contractual aceptado por las partes.
      </p>
      <p>
        Para la interpretación, cumplimiento y ejecución de las obligaciones
        derivadas de los presentes Términos y Condiciones, el Acuerdo de
        Servicio y cualquier documento que derive de los mismos las Partes se
        someten expresa e irrevocablemente a la jurisdicción de los tribunales
        competentes de Lima (para contratos suscritos con CREHANA EDUCATION PERU
        S.A.C.), Delaware, Estados Unidos (para contratos suscritos con CREHANA
        EDUCATION, INC.), Bogotá (para contratos suscritos con CREHANA EDUCATION
        COLOMBIA S.A.S.), Santiago de Chile (para contratos suscritos con
        CREHANA EDUCATION CHILE CAPACITACIONES SPA y CREHANA CHILE SPA), Buenos
        Aires (para contratos suscritos con Wormhole S.A.), Ciudad de México
        (para contratos suscritos con CREHANA EDUCATION MÉXICO S. DE R.L. DE
        C.V.), renunciando de manera expresa e irrevocable a cualquier otro
        fuero que tuvieren o llegaran a adquirir por cualquier razón.
      </p>
    </section>
    <section>
      <Subtitle>15. Vigencia</Subtitle>
      <p>
        La relación entre las partes estará vigente durante el plazo señalado en
        el Acuerdo de Servicio.
      </p>
      <p>
        El plazo del servicio contratado inicia desde la fecha de cargue del
        HIRS o fecha en que se haya culminado el proceso de on-boarding, aquello
        que suceda primero, no necesariamente coincidirá con la fecha de
        suscripción del acuerdo, y la duración de dichos accesos será el
        establecido en el Acuerdo de Servicio, para lo cual, el Cliente se
        obliga a brindar a Crehana todas las facilidades y a proporcionarle toda
        la información y/o documentación requerida por parte de Crehana de forma
        previa a la activación del servicio y onboarding.
      </p>
      <p>
        En caso de que por cualquier motivo el Cliente se demore en proporcionar
        las facilidades y/o en proporcionar toda la información y/o
        documentación requerida, Crehana no será responsable por dicha demora y
        lo anterior no eximirá al Cliente de cumplir sus obligaciones de pago en
        los plazos establecidos en el Acuerdo de Servicio. En el caso mencionado
        en el que el Cliente sea quien genere las demoras, el plazo de duración
        del servicio empezará a contarse desde la fecha de suscripción del
        acuerdo.
      </p>
      <p>
        Al término de la vigencia señalada en el Acuerdo de Servicio, la
        prestación de los Servicios se renovará automáticamente.
      </p>
      <p>
        En dicho caso, la Contraprestación se pagará y facturará de conformidad
        con el precio de lista (sin descuentos).
      </p>
      <p>
        Si el Cliente no desea que el Servicio sea renovado automáticamente,
        deberá comunicarse con Crehana por correo electrónico dirigido a el o la
        Ejecutiva de Cuenta, con copia a <Link href="legal@crehana.com" /> y{' '}
        <Link href="billing@crehana.com" /> sesenta (60) días calendarios
        previos al término del vencimiento.
      </p>
      <p>
        Si el Servicio ya fue renovado automáticamente, el Cliente deberá
        notificar su voluntad de terminar con el acuerdo dentro de los quince
        (15) primeros días calendario y la terminación aplicará al mes
        calendario siguiente.
      </p>
    </section>
    <section>
      <Subtitle>
        16. Integridad de los presentes Términos y Condiciones
      </Subtitle>
      <p>
        Los presentes términos y condiciones constituyen el acuerdo completo
        entre las Partes en relación con los servicios y otorgamiento de
        Licencia, según corresponda, y sustituye todas las comunicaciones,
        propuestas y representaciones anteriores o contemporáneas, orales o
        escritas, con respecto a su objeto.
      </p>
    </section>
    <section>
      <Subtitle>16. Ciberseguridad</Subtitle>
      <p>
        <ul>
          {[
            {
              mark: 'A.',
              title: 'Responsabilidad del Usuario en Materia de Seguridad',
              content:
                'El Cliente será el único responsable de la custodia y confidencialidad de sus credenciales de acceso a la plataforma, incluyendo su contraseña, y se compromete a no compartir dichas credenciales con terceros. El Usuario asume toda responsabilidad por cualquier actividad realizada desde su cuenta, independientemente de que dicha actividad haya sido autorizada por él o no. En caso de detectar cualquier uso no autorizado de su cuenta, el Cliente deberá notificar a Crehana de manera inmediata a través de los canales de contacto establecidos. Crehana no asumirá responsabilidad por el acceso no autorizado a la cuenta del Usuario/Cliente como resultado del incumplimiento de esta disposición.',
            },
            {
              mark: 'B',
              title: 'Medidas de Seguridad y Protección de la Información',
              content:
                'Crehana adopta las medidas técnicas, administrativas y organizativas razonables y necesarias para garantizar la seguridad, integridad y confidencialidad de los datos personales e información financiera del Usuario, de acuerdo con las normativas aplicables en materia de protección de datos y seguridad de la información,. Sin embargo, el Cliente reconoce y acepta que, dada la naturaleza del entorno digital, Crehana no puede garantizar la seguridad absoluta de la información almacenada o transmitida a través de la plataforma.',
            },
            {
              mark: 'C.',
              title: 'Notificación de Incidentes de Seguridad',
              content:
                'En caso de que Crehana detecte cualquier vulneración de seguridad o incidente que comprometa los datos personales o la seguridad de la información de los Usuarios, ya sea mediante ataques cibernéticos, accesos no autorizados, filtraciones de datos o cualquier otro tipo de brecha de seguridad, Crehana se compromete a notificar al Cliente afectado en el menor tiempo posible, conforme a lo establecido en la legislación vigente, y tomará las medidas necesarias para mitigar los efectos de dicho incidente. Crehana se reserva el derecho de investigar cualquier incidente y cooperar con las autoridades competentes en caso de que sea necesario.',
            },
            {
              mark: 'D.',
              title:
                'Prohibición de Conductas Ilícitas Relacionadas con la Ciberseguridad',
              content:
                'El Cliente/Usuario se obliga a no realizar, directa o indirectamente, actividades que puedan comprometer la seguridad de la plataforma, incluidas, pero no limitadas a, la introducción de virus, troyanos, gusanos, bombas lógicas o cualquier otro material tecnológicamente dañino, ni intentar obtener acceso no autorizado a la plataforma, los servidores en los que se encuentra alojada, bases de datos u otros sistemas informáticos relacionados. Cualquier intento o acción de este tipo podrá ser considerado una infracción grave y podrá derivar en la suspensión o cancelación inmediata de la cuenta del Cliente/Usuario, sin perjuicio de las acciones civiles y penales que Crehana pudiera emprender conforme a derecho.',
            },
            {
              mark: 'E.',
              title:
                'Conformidad con Normativas de Ciberseguridad y Protección de Datos',
              content:
                'Crehana se compromete a cumplir con todas las leyes, regulaciones y estándares internacionales en materia de ciberseguridad y protección de datos. Asimismo, el Cliente/Usuario se compromete a no realizar actos que puedan poner en riesgo el cumplimiento de dichas normativas o comprometer la seguridad de la plataforma, y reconoce que cualquier violación podrá dar lugar a la terminación de su relación con Crehana, además de las sanciones legales correspondientes.',
            },
            {
              mark: 'F.',
              title:
                'Limitación de Responsabilidad por Incidentes de Seguridad',
              content:
                'Crehana no será responsable, en la medida permitida por la ley aplicable, de cualquier daño, pérdida o perjuicio sufrido por el Cliente/Usuario derivado de ataques cibernéticos, vulneraciones de seguridad, malware, accesos no autorizados o cualquier otro tipo de incidente de seguridad que esté fuera del control razonable de Crehana, siempre y cuando esta haya implementado las medidas de seguridad exigidas por la legislación aplicable. El Cliente/Usuario acepta que la navegación por Internet implica riesgos inherentes y que Crehana no puede garantizar la completa inmunidad frente a amenazas de ciberseguridad.',
            },
            {
              mark: 'G.',
              title: 'Cooperación con Autoridades en Materia de Ciberseguridad',
              content:
                'Crehana podrá cooperar con las autoridades competentes en caso de ser requerido para la investigación o persecución de delitos relacionados con la ciberseguridad, ataques cibernéticos, violaciones de seguridad o cualquier otra actividad ilícita detectada en la plataforma. El Cliente/Usuario acepta que su información pueda ser proporcionada a las autoridades conforme a los requerimientos legales pertinentes, siempre que dichas acciones se realicen conforme a las normativas de protección de datos aplicables.',
            },
          ].map(({ mark, title, content }) => (
            <li
              key={mark}
              className="tw-relative"
              style={{
                listStyleType: 'none',
              }}
            >
              <span
                className="tw-absolute tw-font-semibold"
                style={{
                  left: '-2rem',
                }}
              >
                {mark}
              </span>
              <span className="tw-font-semibold">{title}</span>
              <br />
              <span>{content}</span>
            </li>
          ))}
        </ul>
      </p>
    </section>
    <section>
      <Subtitle>17. Datos de contacto</Subtitle>
      <p>
        Por favor contáctenos a través del correo electrónico a el o la
        Ejecutiva de Cuenta, con copia a <Link href="legal@crehana.com" /> en
        caso de tener alguna duda de los presentes Términos y Condiciones, los
        alcances de los Servicios o reportar cualquier incidencia.
      </p>
    </section>
  </RouteWrapper>
);

export default TermsAndConditions;
